export default __webpack_public_path__ + "static/media/no_user.b5fd3bd5.png";